const thirdParty = {
  thirdParty: {
    pageHeader: 'Rapports de tiers',
    clearState: 'Effacer l’état',
    register: 'Enregistrer',
    systemRegistrationSummary: 'Résumé de l’enregistrement du système',
    registrationProgress: '%{registration_in_progress} En cours',
    registrationComplete: '%{registration_complete} Terminé',
    thirdPartyLogin: 'Veuillez vous connecter en tant que propriétaire du site pour gérer votre compte PowerDash',
    thirdPartyInvalidURI: 'L’URL demandé est invalide ou la ressource demandée, tel qu’un système, n’existe pas.'
  }
};

export default thirdParty;
